<template>

  <div>
    
      <div @touchstart="restSlide" class="bg-white sticky-top px-4 z-3" v-if="index === 0 || (index > 0 && source.previousDate !== source.Date)">
        <div class="small light-mix-black-40 pb-1">
          {{ source.Date }}
        </div>
      </div>
  
      <div class="overflow-hidden">
        <div class="list-group list-group-flush" :style="deleteSlider">
          <a role="button" class="list-group-item list-group-item-action py-3 d-flex justify-content-between align-items-start position-relative"
          @touchstart="touchStart"
          @touchmove='touchMove'
          @touchend.capture="touchEnd"
          @click.stop.prevent="handleClick()"
          >



          <!-- 左側按鈕 -->
          <div 
          :data-index="index" 
          class="arrived-btn"
          :class="{ active: source.Arrived && source.Arrived.trim() !== '' && !source.Arrived.includes('未') }"
          @click.stop.prevent="arrivedChecked($event)">
        </div>
        <div 
          :data-index="index" 
          class="paid-btn"
          :class="{ active: source.Paid && source.Paid.trim() !== '' && !source.Paid.includes('未') }"
          @click.stop.prevent="paidChecked($event)">
        </div>


            <div class="ms-2 me-3 my-auto">
                <div v-if="source.IBV && !source.BV" class="list-icon rounded-circle bg-warning text-white flexCenter position-relative">
                  <b class="small">IBV</b>
                  <span v-if="source.Modified" class="flexCenter position-absolute checked translate-middle bg-white rounded-pill">
                    <svg class="text-success" width="20" height="20"><use xlink:href="#check-circle"/></svg>
                  </span>
                </div>
                <div v-else-if="source.BV && !source.IBV" class="list-icon rounded-circle bg-info text-white flexCenter">
                <b class="small">BV</b>
                </div>
                <div v-else-if="source.IBV && source.BV" class="list-icon flexCenter flex-column position-relative">
                  <div class="semi-circle bg-warning flexCenter"><b class="badge text-white p-0 mt-1">IBV</b></div>
                  <div class="semi-circle2 bg-info flexCenter"><b class="badge text-white p-0">BV</b></div>
                  <span v-if="source.Modified" class="flexCenter position-absolute checked translate-middle bg-white rounded-pill">
                    <svg class="text-success" width="20" height="20"><use xlink:href="#check-circle"/></svg>
                  </span>
                </div>
            </div>

            <div class="flex-1 overflow-hidden">
                <!-- title & price -->
                <div class="d-flex justify-content-between align-items-start overflow-hidden">
                <div class="me-auto overflow-hidden">
                    <div class="small light-mix-black-50 text-truncate">
                    {{ source.Customer }}
                    </div>
                    <div class="text-truncate">
                    {{ source.Item }}
                    </div>
                    <div class="small light-mix-black-50 text-truncate mb-1">
                    {{ source.Memo }}
                    </div>
                </div>
                <span class="ms-3 me-2 fs-5.5 align-self-start mt-19">${{ source.Total }}</span>
                </div>

                <!-- chips -->
                <div class="d-flex align-items-center">
                <small v-if="source.IBV && !source.BV" class="rounded-pill border border-secondary-subtle px-2 text-black-50 align-self-end me-1">
                    <span><b>IBV</b>&nbsp;<b class="text-primary">{{ source.IBV }}</b></span>
                </small>
                <small v-else-if="source.BV && !source.IBV" class="rounded-pill border border-secondary-subtle px-2 text-black-50 align-self-end me-1">
                    <span><b>BV</b>&nbsp;<b class="text-primary">{{ source.BV }}</b></span>
                </small>
                <span v-else-if="source.IBV && source.BV">
                  <small class="rounded-pill border border-secondary-subtle px-2 text-black-50 align-self-end me-1">
                    <span><b>IBV</b>&nbsp;<b class="text-primary">{{ source.IBV }}</b></span>
                  </small>
                  <small class="rounded-pill border border-secondary-subtle px-2 text-black-50 align-self-end me-1"> 
                    <span><b>BV</b>&nbsp;<b class="text-primary">{{ source.BV }}</b></span>
                  </small>
                </span>

                <span v-if="!source.Arrived || source.Arrived === null || source.Arrived === '' || source.Arrived.includes('未')"
                  @click.stop.prevent="(!liff?.isInClient() && !isTouchDevice()) && arrivedChecked($event)"
                  :class="{'chip-btn': !liff?.isInClient() && !isTouchDevice()}"
                  class="arrived badge rounded-pill warning-mix-black-40 bg-tertiary-mix-white-40">
                  <svg class="bi pe-none me-1" width="14" height="14"><use xlink:href="#truck"/></svg>未到貨
                </span>
                <span v-if="!source.Paid || source.Paid === null || source.Paid === '' || source.Paid.includes('未')"
                  @click.stop.prevent="(!liff?.isInClient() && !isTouchDevice()) && paidChecked($event)"
                  :class="{'chip-btn': !liff?.isInClient() && !isTouchDevice()}"
                  class="paid badge rounded-pill danger-mix-black-20 bg-danger-subtle">
                  <svg class="bi pe-none me-1" width="14" height="14"><use xlink:href="#pay"/></svg>未付款
                </span>

                </div>
            </div>
            <!-- 右側按鈕 -->
            <!-- copy & delete btn -->
            <div :data-index="index" class="delete-btn" @click.stop.prevent="openModal('slideDel', source, index)"></div>
            <!-- 未訂閱且超額：所有訂單行動版複製按鈕都顯示提示 -->
            <div v-if="source.cannotCopy" :data-index="index" class="copy-btn" @click.stop.prevent="showQuotaAlert()"></div>
            <!-- 正常狀態或有訂閱：顯示正常複製按鈕 -->
            <div v-else :data-index="index" class="copy-btn" @click.stop.prevent="openModal('copy', source, index)"></div>
            <!-- copy btn用於電腦瀏覽器：未訂閱且超額時隱藏 -->
            <button v-if="!source.cannotCopy" type="button" @click.stop.prevent="openModal('copy', source, index)"
              class="z-20 position-absolute top-0 end-0 mt-2 me-3
              btn copy btn-outline-primary rounded-pill flexCenter fw-medium"
              style="--bs-btn-padding-y: .125rem; --bs-btn-padding-x: .5rem; --bs-btn-font-size: .8125rem;">
              <svg class="bi pe-none" style="margin-right: 2px" width="15" height="15"><use xlink:href="#copy"/></svg>
              複製訂單
            </button>
          </a>
        </div>
      </div>

    </div>

  </template>
  
  <script>
  /* eslint-disable vue/no-mutating-props */
  import { emitter } from '@/utils/eventBus.js'
  import liff from '@line/liff';

  export default {
    name: 'ListItem',
    props: {
      index: {
        type: Number
      },
      source: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data () {
      return {
        initialOffset: 0,
        startX: 0,  //触摸位置
        endX: 0,   //结束位置
        moveX: 0,  //滑动时的位置
        disX: 0,  //移动距离
        startY: 0,  //触摸位置
        endY: 0,   //结束位置
        moveY: 0,  //滑动时的位置
        disY: 0,  //移动距离
        deleteSlider: 'transform:translateX(0px)',//滑动时的效果,使用v-bind:style="deleteSlider"
        isTouching: false,
        isClicking: false,
        isMoving: '',
        touchStartTime: null,
        justClosed: false,

        slideDirection: null, // 新增：記錄滑動方向
        rightSlideWidth: 180, // 右滑最大寬度
        leftSlideWidth: 180   // 左滑最大寬度
      }
    },

    setup(props) {
      const arrivedChecked = (event) => {
        const newStatus = (!props.source.Arrived || 
            props.source.Arrived === null || 
            props.source.Arrived === '' || 
            props.source.Arrived.includes('未')) ? '已到貨' : '';
        
        emitter.emit('updateState', {
          ...props.source,
          Arrived: newStatus
        });
        event.target.classList.toggle('active');
      };

      const paidChecked = (event) => {
        const newStatus = (!props.source.Paid || 
            props.source.Paid === null || 
            props.source.Paid === '' || 
            props.source.Paid.includes('未')) ? '已付款' : '';
        
        emitter.emit('updateState', {
          ...props.source,
          Paid: newStatus
        });
        event.target.classList.toggle('active');
      };

      return {
        arrivedChecked,
        paidChecked
      };
    },
    created() {
        emitter.on('restSlide', () => {
            this.restSlide();
        });
    },
    beforeUnmount() {
        emitter.off('restSlide');
    },
    methods: {
        isTouchDevice() {
          return 'ontouchstart' in window && 
            (navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1);
        },
        handleClick() { // 检查点击
          if (this.checkSlide()) {
            this.restSlide();
            this.justClosed = true;
            setTimeout(() => { this.justClosed = false; }, 50);
          } else {
            // 是否為liff或者行動裝置
            if (liff.isInClient() || this.isTouchDevice()) {
              this.isClicking = true;
              this.openModal('order', this.source, this.index);
            } else { //電腦版直接打開modal
              this.openModal('order', this.source, this.index);
            }
          }
        },
        openModal(type, data, index) {
          emitter.emit('openModal', {type, data, index});
        },
        showQuotaAlert() {
          // 觸發 MainView 的額度超限提示
          emitter.emit('showQuotaAlert');
        },
        checkSlide() { // 检查是否有已滑动的滑块
          let listItems = document.querySelectorAll('.list-group');
          return Array.from(listItems).some(item => item.style.transform !== "translateX(0px)");
        },
        restSlide() { // 重置所有滑块位置
          document.querySelectorAll('.list-group').forEach(item => {
            item.style.transform = "translateX(0px)";
          });
        },
        resetSlider(e) { // 将不是触发事件的其他滑块重置为起点
          document.querySelectorAll('.list-group').forEach(slider => {
            // 如果当前滑块不是触发事件的滑块，则将其重置为起点
            if (slider !== e) {
                slider.style.transform = "translateX(0px)"; // 重置滑块位置
            }
          });
        },
        touchStart(e) {
          // 檢查是否點擊按鈕
          const isButton = e.target.closest('.arrived-btn, .paid-btn, .delete-btn, .copy-btn');
          if(isButton) {
            return;
          }

          // 獲取當前transform值並記錄初始位置
          const currentTransform = e.currentTarget.parentElement.style.transform;
          this.initialOffset = currentTransform ? parseInt(currentTransform.match(/-?\d+/)[0]) : 0;
          
          this.touchStartTime = new Date().getTime();
          if(e.touches.length == 1){
            this.isTouching = true;
            this.startX = e.touches[0].clientX;
            this.startY = e.touches[0].clientY;
            this.isMoving = false;
            this.slideDirection = null;
          }
        },
        touchMove(e){
          this.isMoving = true;
          if(e.touches.length == 1) {
            this.moveX = e.touches[0].clientX
            this.moveY = e.touches[0].clientY
            this.disX = this.startX - this.moveX;
            this.disY = this.startY - this.moveY;

            // 调用 resetSlider 函数，将其他滑块重置为起点
            this.resetSlider(e.currentTarget.parentElement);

            let slope = Math.abs(this.disY / this.disX);
            if (slope <= 0.5) {
              e.preventDefault();

              // 計算新的位移 = 初始位移 - 當前滑動距離
              const newOffset = this.initialOffset + (this.moveX - this.startX);
              
              // 添加彈性效果
              let finalOffset = newOffset;
              let scaleX = 1;
              const springFactor = 0.3; // 控制彈性效果的強度
              const scaleFactor = 0.001; // 控制拉伸程度

              if (newOffset > this.leftSlideWidth) {
                const overDistance = newOffset - this.leftSlideWidth;
                finalOffset = this.leftSlideWidth + (overDistance * springFactor);
                scaleX = 1 + (overDistance * scaleFactor);
              } else if (newOffset < -this.rightSlideWidth) {
                const overDistance = -this.rightSlideWidth - newOffset;
                finalOffset = -this.rightSlideWidth - (overDistance * springFactor);
                scaleX = 1 + (overDistance * scaleFactor);
              }

              this.deleteSlider = `transform: translateX(${finalOffset}px) scaleX(${scaleX})`;
            }
          }
        },
        touchEnd(e) {
          const touchEndTime = new Date().getTime();
          const touchDuration = touchEndTime - this.touchStartTime;

          if (!this.justClosed && touchDuration < 200 && Math.abs(this.disX) < 10 && Math.abs(this.disY) < 10) {
            if (!this.checkSlide()) {
              this.openModal('order', this.source, this.index);
            }
          } else {
            setTimeout(() => {
              if (this.isTouching && !this.isClicking) {
                this.endX = e.changedTouches[0].clientX;
                this.endY = e.changedTouches[0].clientY;
                this.disX = this.startX - this.endX;
                
                // 計算最終位置 = 初始位置 - 總位移
                const finalPosition = this.initialOffset - this.disX;
                
                // 根據最終位置決定展開或收起
                if (finalPosition > this.leftSlideWidth/2) {
                  this.deleteSlider = `transform: translateX(${this.leftSlideWidth}px) scaleX(1)`;
                } else if (finalPosition < -this.rightSlideWidth/2) {
                  this.deleteSlider = `transform: translateX(-${this.rightSlideWidth}px) scaleX(1)`;
                } else {
                  this.deleteSlider = "transform: translateX(0px) scaleX(1)";
                }
              } else if (this.checkSlide()) {
                this.restSlide();
              }
              
              this.isTouching = false;
              this.isClicking = false;
              this.slideDirection = null;
              this.initialOffset = 0;
            }, 5);
          }
        }

    }
  }
  </script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .list-group {
    transition: transform 0.3s;
    .delete-btn,
    .copy-btn,
    .arrived-btn,
    .paid-btn {
      &::after {
        position: absolute;
        top: 0;
        bottom: 0;
        color: white;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 90px;
      }
    }

    // 新增的左側按鈕樣式    
    .arrived-btn {
      &::after {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 256 256' width='24' height='24'%3E%3Crect fill='none' height='256' width='256'/%3E%3Cpath d='M176,92h29.2c5.3,0,10.1,2.6,12,6.5L240,144' fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-width='14'/%3E%3Ccircle cx='188' cy='192' fill='none' r='24' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-width='14'/%3E%3Ccircle cx='68' cy='192' fill='none' r='24' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-width='14'/%3E%3Cline fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-width='14' x1='164' x2='92' y1='192' y2='192'/%3E%3Cpath d='M44,192H24c-4.4,0-8-3.6-8-8V72c0-4.4,3.6-8,8-8h144c4.4,0,8,3.6,8,8v99.2' fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-width='14'/%3E%3Cpath d='M176,144h64v40c0,4.4-3.6,8-8,8h-20' fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-width='14'/%3E%3C/svg%3E");
        left: -180px; // 左側第一個按鈕
        background-color: #fff389;
      }
      &.active {
        &::after {
          content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='24' height='24'%3E%3Cpath fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='28' d='M352,184h58.3999939c10.6000061,0,20.2000122,5.1999969,24,13l45.6000061,91'/%3E%3Ccircle fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='28' cx='136' cy='384' r='48'/%3E%3Cline fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='28' x1='328' y1='384' x2='184' y2='384'/%3E%3Cpath fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='28' d='M195.8818156,128h140.1181844c8.7999878,0,16,7.1999969,16,16v144.0000036'/%3E%3Cpath fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='28' d='M88,384h-40c-8.7999992,0-16-7.2000122-16-16v-224c0-8.8000031,7.2000008-16,16-16h12.1178314'/%3E%3Cpath fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='28' d='M352,288h128v80c0,8.7999878-7.2000122,16-16,16h-14.9456477'/%3E%3Cpath fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='32' d='M448,448.0000173L64,64.0000173'/%3E%3Cpath fill='none' stroke='%2399702c' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' stroke-width='28' d='M376,432c-26.5096741,0-48-21.4903259-48-48'/%3E%3C/svg%3E");
        }
      }
    }
    
    .paid-btn {
      &::after {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='24' height='24'%3E%3Cpath fill='%23be4451' d='M336.7,399.9H208.5c-8.8,0-16-7.2-16-16s7.2-16,16-16h112.1c0-17.7-14.3-32-32-32h-14.9c-14.4,0-28.4-4.2-40.3-12.2 c-46.8-31.2-109.2-25-149,14.8l-56.8,56.9c-6.4,6.1-16.5,6-22.7-0.4c-6-6.2-6-16.1,0-22.3l56.9-56.9 c50.6-50.6,129.9-58.4,189.4-18.8c6.7,4.5,14.5,6.9,22.6,6.8h14.9c35.4,0,64.1,28.7,64.1,64.1v16 C352.7,392.7,345.6,399.9,336.7,399.9z'/%3E%3Cpath fill='%23be4451' d='M144.5,512c-8.8,0-16-7.2-16-16c0-4.2,1.7-8.3,4.7-11.3c13.2-13.3,31.2-20.8,50-20.7h137.6c15.1,0,29.4-7.2,38.5-19.2 l113.3-151c-17.7-4.6-36.4,1.1-48.5,14.8L349,394.5c-5.8,6.7-15.9,7.4-22.6,1.6s-7.4-15.9-1.6-22.6l0.1-0.1l75.1-85.9 c26.5-30.2,71.2-36.1,104.7-13.9c3.9,2.6,6.6,6.5,7.5,11.1c1,4.4,0.1,9-2.3,12.8L384.9,464c-15.2,20.1-38.9,32-64.1,32H183.1 c-10.3,0-20.1,4.1-27.3,11.3C152.8,510.3,148.7,512,144.5,512z'/%3E%3Ccircle fill='none' stroke='%23be4451' stroke-linecap='round' stroke-miterlimit='10' stroke-width='32' cx='258' cy='130.1' r='114'/%3E%3Cpath fill='%23be4451' d='M290.9,128.3c-6.3-3-14.8-5.7-25.5-8.1c-7.7-1.9-13.6-3.7-17.7-5.4c-4.1-1.7-7.1-3.6-9-5.8s-2.8-4.9-2.8-8.1 c0-4.8,1.9-8.5,5.7-11s9-3.8,15.6-3.8c6,0,11,1.3,15,3.9s6.4,5.8,7.1,9.6c1,2.2,2.7,3.2,5.2,3.2h17.1c1.1,0,2-0.4,2.7-1.1 s1.1-1.6,1.1-2.7c-0.2-4.4-1.8-9-4.8-13.7c-2.9-4.7-7.2-8.8-12.8-12.3s-12.3-5.9-20.1-6.9V53.4c0-1.3-0.4-2.4-1.2-3.2 c-0.8-0.8-1.8-1.2-3.1-1.2h-11.2c-1.2,0-2.2,0.4-3.1,1.2c-0.8,0.8-1.3,1.8-1.3,3.2v12.4c-11.8,1.4-21,5.4-27.8,11.9 s-10.2,14.4-10.2,23.8c0,10.3,3.3,18.2,9.9,23.8c6.6,5.5,17,10,31.1,13.3c8.5,2.3,15,4.2,19.3,5.8c4.4,1.6,7.7,3.5,9.8,5.7 c2.2,2.2,3.2,4.9,3.2,8.1c0,4.9-2.1,8.8-6.4,11.6c-4.3,2.8-10.5,4.2-18.8,4.2c-7.4,0-13.3-1.4-17.5-4.1c-4.3-2.8-7.1-6.2-8.4-10.3 c-0.7-1.2-1.5-2.1-2.2-2.6c-0.8-0.5-1.9-0.8-3.3-0.8h-16.2c-1.1,0-2,0.4-2.8,1.2s-1.2,1.7-1.2,2.6c0.2,5.5,1.9,10.7,5.1,15.6 c3.2,4.9,7.9,9,14,12.3c6.2,3.4,13.6,5.5,22.2,6.3v12.6c0,1.3,0.4,2.4,1.3,3.2c0.8,0.8,1.9,1.2,3.1,1.2h11.2c1.3,0,2.4-0.4,3.1-1.2 c0.8-0.8,1.2-1.8,1.2-3.2v-12.6c12.7-1.3,22.8-5.2,30.3-11.7s11.2-14.9,11.2-25.4c0-7.1-1.5-12.9-4.5-17.5 C301.9,135.1,297.2,131.3,290.9,128.3z'/%3E%3C/svg%3E");
        left: -90px; // 左側第二個按鈕
        background-color: rgb(237 85 101 / 35%);
      }
      &.active {
        &::after {
          content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 512 512'%3E%3Cpath fill='%23be4451' d='M304.5 139.6c-2.6-4.5-7.3-8.3-13.6-11.3s-14.8-5.7-25.5-8.1c-7.7-1.9-13.6-3.7-17.7-5.4-4.1-1.7-7.1-3.6-9-5.8-1.9-2.2-2.8-4.9-2.8-8.1 0-4.8 1.9-8.5 5.7-11 3.8-2.5 9-3.8 15.6-3.8 6 0 11 1.3 15 3.9 4 2.6 6.4 5.8 7.1 9.6 1 2.2 2.7 3.2 5.2 3.2h17.1c1.1 0 2-.4 2.7-1.1s1.1-1.6 1.1-2.7c-.2-4.4-1.8-9-4.8-13.7-2.9-4.7-7.2-8.8-12.8-12.3s-12.3-5.9-20.1-6.9v-12.7c0-1.3-.4-2.4-1.2-3.2s-1.8-1.2-3.1-1.2h-11.2c-1.2 0-2.2.4-3.1 1.2-.8.8-1.3 1.8-1.3 3.2v12.4c-11.8 1.4-21 5.4-27.8 11.9-6.8 6.5-10.2 14.4-10.2 23.8 0 10.3 3.3 18.2 9.9 23.8 6.6 5.5 17 10 31.1 13.3 8.5 2.3 15 4.2 19.3 5.8 4.4 1.6 7.7 3.5 9.8 5.7 2.2 2.2 3.2 4.9 3.2 8.1 0 4.9-2.1 8.8-6.4 11.6-.3.2-.6.4-.9.5-.7.4-1.5.8-2.4 1.2-.1 0-.1 0-.2.1-.5.2-1 .4-1.6.6-.1 0-.2.1-.4.1-.2.1-.5.2-.7.2-.2.1-.5.2-.7.2-5.5 1.4-8.9 7-7.6 12.5 1.1 4.9 5.4 8.2 10.2 8.2.7 0 1.4-.1 2-.2 1.2-.2 2.3-.5 3.4-.8.6-.2 1.2-.4 1.8-.6.6-.2 1.2-.4 1.8-.6 1.7-1.1 3.3-2.3 4.8-3.6 7.5-6.5 11.2-14.9 11.2-25.4 0-7.1-1.5-12.9-4.5-17.5Z'/%3E%3Cline fill='none' stroke='%23be4451' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' x1='293' y1='384' x2='208.5' y2='384'/%3E%3Cpath fill='none' stroke='%23be4451' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M16.2 384l56.9-56.9c25.3-25.3 59-39.3 94.9-39.3 11.4 0 22.7 1.4 33.6 4.3'/%3E%3Cpath fill='none' stroke='%23be4451' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M160.9 70.4c20.1-32.6 56.1-54.3 97.1-54.3 63 0 114 51 114 114 0 41.1-21.7 77-54.3 97.1'/%3E%3Cpath fill='none' stroke='%23be4451' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M448 448 64 64'/%3E%3Cpath fill='none' stroke='%23be4451' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M446.2 355.7l50.4-67.2c-5.2-5.3-17.2-9.5-17.2-9.5-6.1-1.9-12.5-2.9-19-2.9-18.5 0-36.1 8-48.3 21.8l-11 12.5'/%3E%3Cpath fill='none' stroke='%23be4451' stroke-linecap='round' stroke-linejoin='round' stroke-width='32' d='M144.5 496c.1-.1-.1-.1-.2-.1 10.2-10.2 24.1-16 38.4-16h138c18 0 35.4-7.8 47.6-21.1'/%3E%3C/svg%3E");
        }
      }
    }

    .delete-btn {
      &::after {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 512 512'%3E%3Cpath d='M112 112l20 320c.95 18.5 14.4 32 32 32h184c17.7 0 30.9-13.5 32-32l20-320' fill='none' stroke='%23ed5565' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/%3E%3Cpath stroke='%23ed5565' stroke-linecap='round' stroke-miterlimit='10' stroke-width='32' d='M80 112h352'/%3E%3Cpath d='M192 112V72h0a23.9 23.9 0 0124-24h80a23.9 23.9 0 0124 24h0v40M256 176v224M184 176l8 224M328 176l-8 224' fill='none' stroke='%23ed5565' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/%3E%3C/svg%3E");
        right: -180px;
        background-color: rgb(237 85 101 / 35%);
      }
    }
    .copy-btn {
      &::after {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 512 512'%3E%3Cpath d='M336 264.1V436c0 24.3-19.1 44-43 44H107c-24 0-43-19.7-43-44V172a44.3 44.3 0 0144-44h94.1a24.6 24.6 0 0117.5 7.4l109.1 111a25.4 25.4 0 017.3 17.8z' fill='none' stroke='%2300a8ca' stroke-linejoin='round' stroke-width='32'/%3E%3Cpath d='M200 128v108a28.3 28.3 0 0028 28h108' fill='none' stroke='%2300a8ca' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/%3E%3Cpath d='M176 128V76a44.3 44.3 0 0144-44h94a24.8 24.8 0 0117.6 7.4l109.1 111A25.1 25.1 0 01448 168v172c0 24.3-19.1 44-43 44H344' fill='none' stroke='%2300a8ca' stroke-linejoin='round' stroke-width='32'/%3E%3Cpath d='M312 32v108a28.3 28.3 0 0028 28h108' fill='none' stroke='%2300a8ca' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'/%3E%3C/svg%3E");
        right: -90px;
        background-color: rgb(0 168 202 / 35%);
      }
    }
    .list-group-item {
      border: 0;
      .list-icon {
        width: 2rem; height: 2rem;
        .checked {
          width: 20px; height: 20px;
          top:97%; left: 97%;
        }
      }
      .copy {
        opacity: 0;
        transition: opacity 0.2s ease;
      }
      &:active {
        background-color: #f8f9fa;
      }
    }
  }
  @media (hover: hover) and (pointer: fine) {
    .list-group-item:hover .copy {
      opacity: 1;
    }
  }

  .mt-19 {margin-top: 19px !important;}

  // BV+IBV標示
  .semi-circle,.semi-circle2 {
    width: 2rem !important;
    height: 1rem !important;
  }
  /* 上半圆 */
  .semi-circle {border-radius:1rem 1rem 0 0; /* 左上、右上、右下、左下 */}
  /* 下半圆 */
  .semi-circle2 {border-radius:0 0 1rem 1rem; /* 左上、右上、右下、左下 */}

  .chip-btn {
    position: relative;
    &:hover {
      &::after {
        content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 512 512'%3E%3Cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M416 128L192 384l-96-96'/%3E%3C/svg%3E");
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50rem;
      }
    }
    &.arrived {
      &:hover {
        &::after {
          background-color: rgb(255 186 74 / 70%);
        }
      }
    }
    &.paid {
      &:hover {
        &::after {
          background-color: rgb(237 85 101 / 70%);
        }
      }
    }
  }
</style>